<button class="dsh-filter-button" [disabled]="disabled" [ngClass]="{ 'dsh-filter-button-active': active }">
    <ng-content></ng-content>
</button>
